module.exports = __webpack_public_path__ + "img/nome_scarpa_3.a2dc6dff.svg";